module.exports = __webpack_public_path__ + "img/address.8b5edb50.png";